import { t } from "i18next";
import APP_URLs from "../consts/url";
import {USER_ROLES} from "../consts/user";

//@ts-expect-error
export const combine = function(...args) {
    const functions = args;
    let lastArgs = [];
    //@ts-expect-error
    return function(...fnArgs) {
        lastArgs = fnArgs;
        while(functions.length) {
            const currFn = functions.shift();
            lastArgs = [currFn(...lastArgs)];
        }
        return lastArgs[0];
    }
}

export const checkCanRead = (roles: USER_ROLES[]) => roles.indexOf(USER_ROLES.USER) !== -1;
export const checkSuperviser = (roles: USER_ROLES[]) => roles.indexOf(USER_ROLES.SUPER) !== -1;
export const getYTvideoLinkFromUrl = (url: string) => { 
    const link = new URL(url);
    const searchParams = Object.fromEntries(link.searchParams);
    const videoId = searchParams.v;
    delete searchParams.v;
    const resultLink = new URL('https://www.youtube.com/embed/' + videoId);
    const paramsToChange = {
        t: (value: string) => {
            const timeStr = value.split('/[a-z]/');
            let seconds = timeStr.find((timeUnit: string) => timeUnit.endsWith('s'));
            if (seconds) {
                seconds = seconds.replace('s', '');
            }
            //@TODO: support minutes
            return {start: seconds};
        }
    }

    let resultParams = {};
    Object.keys(searchParams).forEach((key: string) => {
        //@ts-expect-error
        const paramsToChangeFn = paramsToChange[key] as () => Record<string, string>;
        if (paramsToChangeFn) {
            resultParams = {
                ...resultParams,
                //@ts-expect-error
                ...paramsToChangeFn(searchParams[key]),
            }
            return;
        }
        resultParams = {
            ...resultParams,
            [key]: searchParams[key],
        };
    });
    Object.entries(resultParams).forEach(([key, value]) => {
        resultLink.searchParams.set(key, String(value));
    });

    return resultLink.toString();
};

export const calculateProgress = (total: number, current: number): number => {
    return Math.round((current / total) * 100);
};

export const createOrganisationLink = {
    'thealexanderyerevan': () => `${window.location.origin}${APP_URLs.SIGN_IN_ALEXANDR_EREVAN}`,
}